import PropTypes from 'prop-types'
import {List, Map} from 'immutable'

import SuggestedDeputyBox from './SuggestedDeputyBox'
import useSuggestedDeputies from './useSuggestedDeputies'

import './suggestedDeputies.scss'

const SuggestedDeputies = ({
  context,
  deputies = List(),
  everplanId,
  firstGroupId,
  itemResponses = List(),
  numberToDisplay = 5,
  onAddDeputy,
  onShareWithDeputy,
  title = 'Share this item with',
  vaultExtension = Map()
}) => {
  const {onDismiss, onInvite, suggestedDeputies} = useSuggestedDeputies({
    context,
    deputies,
    everplanId,
    firstGroupId,
    itemResponses,
    numberToDisplay,
    onAddDeputy,
    onShareWithDeputy,
    vaultExtension
  })

  if (suggestedDeputies.isEmpty())
    return null

  return (
    <div className='suggested-deputies'>
      {
        title &&
        <div className='suggested-deputies__title'>
          {title}
        </div>
      }
      <div className='suggested-deputies__container'>
        {
          suggestedDeputies.map(contact => (
            <SuggestedDeputyBox
              contact={contact}
              deputies={deputies}
              key={contact.get('id')}
              onDismiss={onDismiss}
              onInvite={onInvite}
            />
          ))
        }
      </div>
    </div>
  )
}

SuggestedDeputies.propTypes = {
  context: PropTypes.string,
  deputies: PropTypes.instanceOf(List),
  everplanId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  firstGroupId: PropTypes.string,
  itemResponses: PropTypes.instanceOf(List),
  numberToDisplay: PropTypes.number,
  onAddDeputy: PropTypes.func,
  onShareWithDeputy: PropTypes.func,
  title: PropTypes.string,
  vaultExtension: PropTypes.instanceOf(Map)
}

export default SuggestedDeputies
